
import { Component, inject, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
@Component({
    selector: 'cerrix-toggle',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule],
    templateUrl: './cerrix-toggle.component.html',
    styleUrl: './cerrix-toggle.component.scss'
})
export class CerrixToggleComponent implements ControlValueAccessor {
  protected ngControl = inject(NgControl, { optional: true, self: true });

  @Input() public labelOn?: string;
  @Input() public labelOff?: string;
  @Input() public disabled?: boolean = false;
  @Input() public value: boolean = false;
  @Input() public dataUiid: string = 'undefined';

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  private onValueChange = (value: boolean) => {};
  private onTouched = () => {};

  public writeValue(value: boolean): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: boolean) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected onClick(): void {
    if (!this.disabled) {
      this.value = !this.value;
      this.onValueChange(this.value);
    }
  }
}
